import apiCacheReducer from './api-cache'
import formReducer from './form'
import genericSlice from './generic-slice'
import navReducer from './nav'
import pagerReducer from './pager'
import uiReducer from './ui'
import siteGuideReducer from './site-guide'
import soundReducer from './sound'
import visitedRoutesReducer from './visited-routes'

const indexReducer = {
    apiCaches: apiCacheReducer,
    characters: genericSlice('CHARACTERS', [], 'uuid'),
    content: genericSlice('PAGE_CONTENT', [], 'uuid'),
    forms: formReducer,
    keyIssues: genericSlice('KEY_ISSUES', [], 'uuid'),
    keyIssueCategories: genericSlice('KEY_ISSUE_CATEGORIES', [], 'uuid'),
    keyIssueShort: genericSlice('KEY_ISSUES', [], 'uuid'),
    locations: genericSlice('LOCATIONS', [], 'uuid'),
    locationStories: genericSlice('LOCATION_STORIES', [], 'uuid'),
    metaData: genericSlice('META_DATA_PAGES', [], 'uuid'),
    nav: navReducer,
    pager: pagerReducer,
    realWorldStories: genericSlice('REAL_WORLD_STORIES', [], 'uuid'),
    resources: genericSlice('RESOURCES', [], 'uuid'),
    siteGuide: siteGuideReducer,
    sound: soundReducer,
    stories: genericSlice('STORIES', [], 'uuid'),
    ui: uiReducer,
    visitedRoutes: visitedRoutesReducer
}

export default indexReducer
